// extracted by mini-css-extract-plugin
export default {"bank-card-icons":"bank-card-icons--ZPjW","icon-group":"icon-group--Hlij","visa":"visa--SDMZ","mastercard":"mastercard--+A0C","sberbank":"sberbank--X8Ue"};